import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css' // Progress 进度条样式

Vue.use(Router)

const router = new Router({
  mode: 'history',

  routes: [
    {
      path: '/',
      component: Layout,
      redirect: '/works',
      children: [
        {
          path: '/about',
          name: 'about',
          component: () => import('@/views/about/index'),
        },
        {
          path: '/works',
          name: 'works',
          component: () => import('@/views/works/index'),
          meta: {
            title: '作品透视'
          }
        },
        {
          path: '/works/:id',
          name: 'detail',
          component: () => import('@/views/detail/index'),
        },
        {
          path: '/contact',
          name: 'contact',
          component: () => import('@/views/contact/index'),
          meta: {
            title: '取得联系'
          }
        },
        {
          path: '/test',
          name: 'test',
          component: () => import('@/views/test/index'),
          meta: {
            title: '测试'
          }
        },
      ]
    },
    {
      path: '/404',
      component: () => import('@/views/error/404'),
      hidden: true
    },
    // 404 page must be placed at the end !!!
    { path: '*', redirect: '/404', hidden: true }
  ],

  scrollBehavior(to, from, saveScrollPosition) {
    return saveScrollPosition || {y: 0};
  }
});

NProgress.configure({
  showSpinner: false,
  trickleSpeed: 200
});

router.beforeEach((to, from, next) => {
  NProgress.start();
  next();
});

router.afterEach((to, from) => {
  NProgress.done();
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js